<template>
	<div v-if="active">
		<div
			:style="[$_appViewPosition_positionTop, $_appViewPosition_positionBottom]"
			class='fixed-nav'
		>
			<div class="modal-buttons" :style="[$_appViewPosition_positionTop]">
				<button class='btn recipe-close modal-close' @click="onClose()">
					Chiudi <i class="fa fa-times" aria-hidden="true"></i>
				</button>
			</div>

			<recipe-content
				:recipe='recipe'
				typeCTA='modal'
				v-on="$listeners"
				v-bind="$attrs"
			/>
		</div>
	</div>
</template>

<script>

import { RecipeApi } from '../api/RecipeApi'
import RecipeContent from './RecipeContent'
import { Recipe } from '../core/Recipe'

export default {
	data () {
		return {
			active: false,
			loading: false,

			recipe: null,

			recipeId: null
		}
	},

	components: {
		RecipeContent
	},

	watch: {
		'$route' (from, to) {
			if (!this.$route.query.recipe) {
				this.close()
			}
		}
	},

	methods: {
		onClose () {
			this.$router.push({ name: this.$route.name })
		},

		close () {
			this.active = false
		},

		closeByKey (e) {
			if (e.keyCode === 27) {
				this.onClose()
			}
		},

		open (item) {
			this.recipeId = item.id

			this.loading = true

			this.loadRecipe(this.recipeId).then(_ => {
				this.active = true
				this.loading = false
			}).catch(response => {
				this.loading = false
			})
		},

		loadRecipe (id) {
			return this.rm.recipe(id).then(response => {
				this.recipe = new Recipe(response.body.data.resource)
				this.$router.push({ name: this.$route.name, query: { recipe: this.recipe.id } })
			})
		}
	},

	mounted () {
		this.rm = new RecipeApi()
		window.addEventListener('keyup', this.closeByKey)
	},

	destroyed () {
		window.removeEventListener('keyup', this.closeByKey)
	}
}

</script>

<style scoped>

.modal-buttons {
	padding: 15px 15px;
	position: fixed;
	background-color: #ffffff;
	z-index: 4;
	width: inherit;
	display: flex;
	left: 0;
	top: 0;
}

.modal-close {
	margin: 0 0 0 auto;
}

.fixed-nav {
	padding-top: 40px;
	top: 0;
	left: 0;
	background: white;
	z-index: 9999;
	width: 100%;
	position: absolute;
}

.recipe-close.modal-close {
    background-color: #f25f5c;
    color: #ffffff;
}
.recipe-close.modal-close:hover {
    background-color: #f04844;
    color: #ffffff;
}

@media only screen and (max-width: 992px) {
	.modal-buttons {
		right: 0;
		left: 0;
		padding: 15px;
		width: 100%;
	}
}
</style>
